import { cx, css } from 'emotion'
import baseColorRepository, {
  name,
} from '@/middlewares/styles/baseColorRepository'

import AppCurrency from '@/components/App/AppCurrency'
import AppNumberWithUnit from '@/components/App/AppNumberWithUnit'
import AppCtr from '@/components/App/AppCtr'
import AppVideoCompletion from '@/components/App/AppVideoCompletion'

import MainTableDeliveryGroupRows from '@/components/Advertiser/Report/StandardReport/MainTableDeliveryGroupRows'

const MainTableCampaignRow = ({ props }) => {
  const {
    fetchedColor,
    campaignReport,
    deliveryGroupReports,
    isOpen,
    f,
    func,
    isHideRevenue,
  } = props

  // 配信グループの表
  const color = baseColorRepository(fetchedColor)
  const backgroundBase3 = css`
    background: ${color[name.base3]};
  `
  const columnStyles = cx('campaign__column', backgroundBase3)

  const iconStylesOpen = () => {
    return ['io__arrow-icon']
  }
  const iconStylesClosed = () => {
    return ['io__arrow-icon', 'io__arrow-icon__turn']
  }

  // 配信グループレポート展開ボタンを押したとき
  const ff = e => {
    e.preventDefault()
    f(campaignReport.id)
  }
  // キャンペーンのBP変更ボタンを押したとき
  const ffunc = e => {
    e.preventDefault()
    func(campaignReport.id, campaignReport.insertionOrderId)
  }

  if (isOpen) {
    return [
      <tr>
        <td class={[columnStyles, 'text-xs-left']}>
          <div onClick={ff}>
            <v-icon class={iconStylesOpen()} style="padding-left: 20px">
              keyboard_arrow_right
            </v-icon>
          </div>
        </td>
        <td class={[columnStyles, 'text-xs-left']} style="padding-left: 20px">
          {campaignReport.name}
        </td>
        <td class={[columnStyles, 'text-xs-center']}>
          <div onClick={ffunc} class="calender">
            <img src={require('@/assets/images/calender.svg')} alt />
          </div>
        </td>

        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.sumOfBudget} />
          </td>
        )}
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.revenueBuyingCurrency} />
          </td>
        )}
        <td class={columnStyles}>
          <AppNumberWithUnit value={campaignReport.imps} local-string />
        </td>
        <td class={columnStyles}>
          <AppNumberWithUnit value={campaignReport.clicks} local-string />
        </td>
        <td class={columnStyles}>
          <AppCtr value={campaignReport.ctr} />
        </td>
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.cpc} />
          </td>
        )}
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.cpm} />
          </td>
        )}
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppVideoCompletion
              value={campaignReport.videoCompletions}
              local-string
            />
          </td>
        )}
      </tr>,
      <MainTableDeliveryGroupRows
        deliveryGroupReports={deliveryGroupReports}
        fetchedColor={fetchedColor}
        isHideRevenue={isHideRevenue}
      />,
    ]
  } else {
    return [
      <tr>
        <td class={[columnStyles, 'text-xs-left']}>
          <div onClick={ff}>
            <v-icon class={iconStylesClosed()} style="margin-left: 20px">
              keyboard_arrow_right
            </v-icon>
          </div>
        </td>
        <td class={[columnStyles, 'text-xs-left']} style="padding-left: 20px">
          {campaignReport.name}
        </td>
        <td class={[columnStyles, 'text-xs-center']}>
          <div onClick={ffunc} class="calender">
            <img src={require('@/assets/images/calender.svg')} alt />
          </div>
        </td>
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.sumOfBudget} />
          </td>
        )}
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.revenueBuyingCurrency} />
          </td>
        )}
        <td class={columnStyles}>
          <AppNumberWithUnit value={campaignReport.imps} local-string />
        </td>
        <td class={columnStyles}>
          <AppNumberWithUnit value={campaignReport.clicks} local-string />
        </td>
        <td class={columnStyles}>
          <AppCtr value={campaignReport.ctr} />
        </td>
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.cpc} />
          </td>
        )}
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppCurrency value={campaignReport.cpm} />
          </td>
        )}
        {!isHideRevenue && (
          <td class={columnStyles}>
            <AppVideoCompletion
              value={campaignReport.videoCompletions}
              local-string
            />
          </td>
        )}
      </tr>,
    ]
  }
}

export default MainTableCampaignRow
